import React, { useState, useEffect } from "react";
import { Dropdown } from "primereact/dropdown";
import SendReminderView from "../../../../Shared/Component/SendReminder/SendReminderView";
import "./AshaIncentiveView.scss";
import { FilterMatchMode } from "primereact/api";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchAshasOnIncentive } from "../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionActions";
import * as masterSelectors from "../../../../Store/Dashboard/AshaAnmSection/AshaAnmSectionSelectors";
import { InputText } from "primereact/inputtext";
import { AshaIncentiveColumns } from "../../../../Shared/Constant/TableConstants";
import CustomDataTable from "../../../../Shared/Component/CustomTable/CustomDataTable";
import { useLanguage } from "../../../ChangeLanguage/LanguageProvider";
import {
  getSelectedDistrictId,
  getTaluka,
  getGlobalAreaType,
} from "../../../../Store/Dashboard/DashboardSelectors";
import GetAreaId from "../../../../Shared/Utils/getAreaId";
import {
  createDropdownFilterTemplate,
  reminderBodyTemplate,
} from "../../../../Shared/Utils/tableColumns";
const AshaIncentiveView = ({
  handleAshaClick,
  split,
  selectedMonth,
  selectedYear,
}) => {
  const instCol = AshaIncentiveColumns();
  const dispatch = useDispatch();
  const area = useSelector(getGlobalAreaType);
  const { t } = useTranslation();
  const { selectedLanguageId } = useLanguage();
  const month = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const years = [
    2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,
    2025,2026
  ];
  const roles = sessionStorage.getItem("userRole");
  const [phcName, setPhcName] = useState([]);
  const [selectedmonths, setSelectedMonths] = useState(selectedMonth);
  const [selectedYears, setSelectedYears] = useState(selectedYear);
  const [data, setData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [, setFilters] = useState(null);
  const [actualIncentive, setActualIncentive] = useState([]);
  const [paidIncentive, setPaidIncentive] = useState([]);
  const ashasOnIncentives = useSelector(masterSelectors.getAshasOnIncentives);
  const district = useSelector(getSelectedDistrictId);
  const taluka = useSelector(getTaluka);
  const [totalActivityCount, setTotalActivityCount] = useState([]);
  const initFilters = () => {
    setFilters({
      ashaId: { value: "", matchMode: FilterMatchMode.CONTAINS },
      ashaName: { value: "", matchMode: FilterMatchMode.CONTAINS },
      mobileNo: { value: "", matchMode: FilterMatchMode.CONTAINS },
      actualIncentive: { value: null, matchMode: FilterMatchMode.EQUALS },
      phcName: { value: null, matchMode: FilterMatchMode.CONTAINS },
      paidIncentive: { value: null, matchMode: FilterMatchMode.EQUALS },
      totalActivityCount: { value: null, matchMode: FilterMatchMode.EQUALS },
      reminderCount: { value: "", matchMode: FilterMatchMode.CONTAINS },
    });
  };
  useEffect(() => {
    dispatch(
      fetchAshasOnIncentive(
        GetAreaId(area),
        selectedLanguageId,
        district,
        taluka,
        roles,
        selectedMonth,
        selectedYear
      )
    );
    initFilters();
  }, [
    dispatch,
    selectedLanguageId,
    district,
    taluka,
    selectedMonth,
    selectedYear,
    roles,
    area,
  ]);
  const incentiveSplits = Array.isArray(ashasOnIncentives)
    ? ashasOnIncentives.map((data) => data.incentiveSplit)
    : [];
  const range = Array.from(new Set(incentiveSplits));

  const [selectedRange, setSelectedRange] = useState(split);
  const extractData = (ashasOnIncentives) => {
    const flattenedArray = Array.isArray(ashasOnIncentives)
      ? ashasOnIncentives.map((item) => item.ashaList).flat()
      : [];

    const paidIncentives = [];
    const actualIncentives = [];
    const activity = [];
    const pnames = [];
    flattenedArray.forEach(
      ({ paidIncentive, actualIncentive, totalActivityCount, phcName }) => {
        paidIncentive && paidIncentives.push(paidIncentive);
        actualIncentive && actualIncentives.push(actualIncentive);
        totalActivityCount && activity.push(totalActivityCount);
        phcName && pnames.push(phcName);
      }
    );
    return { paidIncentives, actualIncentives, activity, pnames };
  };
  useEffect(() => {
    const filteredData = Array.isArray(ashasOnIncentives)
      ? ashasOnIncentives.filter(
          (data) => data.incentiveSplit === selectedRange
        )
      : [];
    setData(filteredData);

    setTimeout(() => {
      if (ashasOnIncentives) {
        const { paidIncentives, actualIncentives, activity, pnames } =
          extractData(ashasOnIncentives);
        setTotalActivityCount(activity);
        setActualIncentive(actualIncentives);
        setPaidIncentive(paidIncentives);
        setPhcName(pnames);
      }
    }, 500);
  }, [selectedRange, ashasOnIncentives]);

  const handleRange = (val) => {
    setSelectedRange(val);
  };
  const handleYear = (val) => {
    setSelectedYears(val);
    setSelectedRange(range[0]);
    dispatch(
      fetchAshasOnIncentive(
        GetAreaId(area),
        selectedLanguageId,
        district,
        taluka,
        roles,
        selectedMonth,
        val
      )
    );
  };

  const handleMonth = (val) => {
    setSelectedMonths(val);
    setSelectedRange(range[0]);
    dispatch(
      fetchAshasOnIncentive(
        GetAreaId(area),
        selectedLanguageId,
        district,
        taluka,
        roles,
        val,
        selectedYear
      )
    );
  };

  const ashaIncentiveFilterTemplate = (options) => {
    return (
      <div className="p-input-icon-right">
        <i className="pi pi-search custom-search-icon" />
        <InputText
          type="text"
          value={options.value}
          onChange={(e) => options.filterApplyCallback(e.target.value)}
          placeholder={t("Search")}
          className="p-column-filter"
        />
      </div>
    );
  };

  const actualIncentiveFilterTemplate = createDropdownFilterTemplate(
    actualIncentive,
    t
  );
  const paidIncentiveFilterTemplate = createDropdownFilterTemplate(
    paidIncentive,
    t
  );
  const activitiesFilterTemplate = createDropdownFilterTemplate(
    totalActivityCount,
    t
  );
  const phcFilterTemplate = createDropdownFilterTemplate(phcName, t);

  const SelectedId = (items) => {
    let idsList = [];
    items.length > 0 &&
      items.forEach((el) => {
        idsList.push(el.ashaid);
      });
    return idsList;
  };

  const handleAshaName = (rowData) => (
    <div
      className="asha-selection"
      onClick={() =>
        handleAshaClick(rowData.ashaid, rowData.ashaName, rowData.isActive, 0)
      }
    >
      {rowData.ashaName}
    </div>
  );
  const handleActivity = (rowData) => (
    <div
      className="asha-selection"
      onClick={() =>
        handleAshaClick(rowData.ashaid, rowData.ashaName, rowData.isActive, 1)
      }
    >
      {rowData.totalActivityCount}
    </div>
  );

  const bodyMethods = {
    ashaName: handleAshaName,
    totalActivityCount: handleActivity,
    remindersCount: reminderBodyTemplate,
  };
  const filterMethods = {
    ashaName: ashaIncentiveFilterTemplate,
    ashaid: ashaIncentiveFilterTemplate,
    mobileNo: ashaIncentiveFilterTemplate,
    stateName: ashaIncentiveFilterTemplate,
    districtName: ashaIncentiveFilterTemplate,
    talukaName: ashaIncentiveFilterTemplate,
    subcenterName: ashaIncentiveFilterTemplate,
    villageName: ashaIncentiveFilterTemplate,
    joiningDate: ashaIncentiveFilterTemplate,
    totalActiveCases: ashaIncentiveFilterTemplate,
    phcName: phcFilterTemplate,
    actualIncentive: actualIncentiveFilterTemplate,
    totalActivityCount: activitiesFilterTemplate,
    remindersCount: ashaIncentiveFilterTemplate,
    paidIncentive: paidIncentiveFilterTemplate,
  };
  return (
    <div>
      <div className="flex flex-wrap  justify-content-between gap-8">
        <div className="flex flex-wrap align-items-center mt-3 gap-2  ">
          <div className="flex text-xl ml-4 text-blue-800 font-light">
            {t("ASHAs Incentive Details")}
          </div>
          <div className="flex align-items-center justify-content-center mt-1">
            <Dropdown
              value={selectedRange}
              onChange={(e) => handleRange(e.value)}
              options={range}
              className="cockpit-dropdown"
            />
          </div>

          <div className="flex align-items-center justify-content-center mt-1">
            <Dropdown
              value={selectedmonths}
              onChange={(e) => handleMonth(e.value)}
              options={month}
              className="cockpit-dropdown"
            />
          </div>

          <div className="flex align-items-center justify-content-center mt-1">
            <Dropdown
              value={selectedYears}
              onChange={(e) => handleYear(e.value)}
              options={years}
              className="cockpit-dropdown"
            />
          </div>
        </div>
        <div className="mt-3 ">
          <SendReminderView
            ashaIds={SelectedId(selectedItems)}
            isDisabled={selectedItems.length === 0}
          />
        </div>
      </div>
      <div className="mt-3">
        <CustomDataTable
          columns={instCol}
          className={"AshaIncentive"}
          data={data.flatMap((item) => item.ashaList)}
          dataKey="ashaid"
          selectedItems={selectedItems}
          onSelectionChange={(e) => setSelectedItems(e.value)}
          filterMethods={filterMethods}
          bodyMethods={bodyMethods}
        />
        <p>
          {" "}
          {data.flatMap((item) => item.ashaList).length + " "}{" "}
          {t("Totalrecord")}
        </p>
      </div>
    </div>
  );
};
export default AshaIncentiveView;
